<template>
  <div>
    <h2 class="mt-6 mb-6">機器權限列表</h2>

    <v-form>
      <v-card-text>
        <v-simple-table class="mb-6">
          <tbody>
            <tr
              v-for="item in tempData"
              @click="checkbox(item)"
              :style="{ cursor: $hasHigherPermission ? 'default' : 'pointer' }"
            >
              <td>
                <v-checkbox v-model="item.available" color="teal" @click.prevent></v-checkbox>
              </td>
              <td>{{ item.serial_number }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.address }}</td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-card-text>

      <div v-if="!$hasHigherPermission" class="text-center">
        <v-btn @click="reset" outlined color="blue-grey lighten-3" class="mr-3">重設</v-btn>
        <v-btn @click="dialog = true" color="teal">變更</v-btn>
      </div>
    </v-form>

    <Confirm @confirm="confirm" :dialog="dialog" title="是否確認變更機器權限？" text />
  </div>
</template>



<script>
import { mapState, mapActions } from "vuex";

import userApi from "@/api/user";

import Confirm from "@/components/Confirm";

export default {
  components: {
    Confirm
  },

  mixins: [],

  props: ["id", "roleId"],
  data() {
    return {
      machines: [],
      tempData: [],

      dialog: false
    };
  },

  computed: {
    $hasHigherPermission() {
      return [0, 300, 400].indexOf(this.roleId) === -1;
    }
  },
  watch: {
    roleId: function() {
      this.init();
    }
  },
  methods: {
    ...mapActions("system", ["set_snackbar"]),

    init() {
      userApi
        .getMachines(this.id)
        .then(res => {
          this.resHandling(res);
        })
        .catch(err => {});
    },

    resHandling(res) {
      this.machines = JSON.parse(JSON.stringify(res.machines));
      this.tempData = JSON.parse(JSON.stringify(res.machines));
    },

    checkbox(item) {
      if (this.$hasHigherPermission) {
        return;
      }

      item.available = !item.available;
    },

    confirm(result) {
      this.dialog = false;

      if (result) {
        this.submit();
      } else {
        this.reset();
      }
    },

    reset() {
      this.tempData = JSON.parse(JSON.stringify(this.machines));
    },

    submit() {
      const machine_ids = [];
      this.tempData.forEach(machine => {
        if (machine.available) {
          machine_ids.push(machine.machine_id);
        }
      });

      if (!machine_ids.length) {
        machine_ids.push(0);
      }

      userApi
        .updateMachines(this.id, {
          machine_ids: machine_ids
        })
        .then(res => {
          if (res.status !== 0) {
            this.set_snackbar({
              color: "error",
              text: res.message
            });

            this.reset();
          } else {
            this.resHandling(res);
          }
        })
        .catch(err => {});
    }
  },

  mounted() {
    this.init();
  }
};
</script>

<style lang="scss" scoped>
</style>
